import type { ProfileEducation, ProfileProject, ProfileWorkExperience } from '../../redux/features/jobFormSlice';

/** Sort by end date descending (most recent first), falling back to start date. */
function sortByEndOrStartDesc(a: { startDate: string; endDate?: string }, b: { startDate: string; endDate?: string }): number {
  const aVal = parseInt(a.endDate || a.startDate) || 0;
  const bVal = parseInt(b.endDate || b.startDate) || 0;
  if (bVal !== aVal) return bVal - aVal;
  return (parseInt(b.startDate) || 0) - (parseInt(a.startDate) || 0);
}

function sortByYearDesc(a: { year: string }, b: { year: string }): number {
  return (parseInt(b.year) || 0) - (parseInt(a.year) || 0);
}

export interface SortedCvEntries {
  workExperiencesByDate: ProfileWorkExperience[];
  educationByDate: ProfileEducation[];
  projectsByYear: ProfileProject[];
  mostRecentWorkExp: { title: string; company: string } | null;
}

/**
 * Sorts profile CV sections by recency (most recent first). Shared by the Profile page's
 * own preview/export and the job-detail-page CV tailoring modal, so both build the exact
 * same "before tailoring" CV data from the same Redux profile state.
 */
export function deriveSortedCvEntries({
  workExperiences,
  education,
  projects,
}: {
  workExperiences: ProfileWorkExperience[];
  education: ProfileEducation[];
  projects: ProfileProject[];
}): SortedCvEntries {
  const workExperiencesByDate = [...workExperiences].sort(sortByEndOrStartDesc);
  const educationByDate = [...education].sort(sortByEndOrStartDesc);
  const projectsByYear = [...projects].sort(sortByYearDesc);
  const mostRecentWorkExp = workExperiencesByDate[0]
    ? { title: workExperiencesByDate[0].title, company: workExperiencesByDate[0].company || '' }
    : null;

  return { workExperiencesByDate, educationByDate, projectsByYear, mostRecentWorkExp };
}
